import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f5f5f5;
    color: #333;
    line-height: 1.6;
  }

  a {
    text-decoration: none;
    color: #1890ff;
    transition: color 0.3s;
    &:hover {
      color: #40a9ff;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    font-weight: 500;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .section {
    padding: 3rem 0;
  }

  .section-title {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    
    &:after {
      content: '';
      display: block;
      width: 60px;
      height: 3px;
      background-color: #1890ff;
      margin: 0.5rem auto;
    }
  }

  .coming-soon {
    background-color: #f0f2f5;
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    
    h3 {
      color: #1890ff;
      margin-bottom: 1rem;
    }
    
    p {
      color: #666;
    }
  }
`;

export default GlobalStyles; 